import { callRpc } from "@/lib/api/rpc";
import { invokeEdgeJson } from "@/lib/api/edge-invoke";

export async function syncMarketplaceRefund(params: {
  connectorId: string;
  orgId: string;
  salesOrderId: string;
  refundId: string;
}): Promise<{ success: boolean; error?: string; provider_sync_status?: string }> {
  const invoked = await invokeEdgeJson<{
    success?: boolean;
    error?: string;
    provider_sync_status?: string;
  }>("marketplace-refund-sync", {
    connector_id: params.connectorId,
    org_id: params.orgId,
    sales_order_id: params.salesOrderId,
    refund_id: params.refundId,
    mode: "LIVE",
  }, { surface: "refund" });
  const result = invoked.data ?? {};
  const success = invoked.success && result.success !== false;
  if (!success) {
    const error = invoked.error || result.error || "Provider refund sync failed";
    try {
      await callRpc("mark_refund_provider_sync", {
        p_refund_id: params.refundId,
        p_status: "error",
        p_error: error.slice(0, 500),
      });
      await callRpc("record_integration_exception", {
        p_org_id: params.orgId,
        p_connector_id: params.connectorId,
        p_exception_type: "refund_provider_sync_failed",
        p_entity_type: "sales_refund",
        p_entity_ref: params.refundId,
        p_external_data: { sales_order_id: params.salesOrderId, error },
      });
    } catch {
      /* canonical refund is already saved; inbox write is best-effort */
    }
    return { success: false, error, provider_sync_status: result.provider_sync_status ?? "error" };
  }
  return {
    success: true,
    error: undefined,
    provider_sync_status: result.provider_sync_status,
  };
}

export async function syncMarketplaceCancel(params: {
  connectorId: string;
  orgId: string;
  salesOrderId: string;
  cancelReason?: string;
}): Promise<{ success: boolean; error?: string; provider_cancel_status?: string }> {
  const invoked = await invokeEdgeJson<{ success?: boolean; error?: string; provider_cancel_status?: string }>("marketplace-cancel-sync", {
    connector_id: params.connectorId,
    org_id: params.orgId,
    sales_order_id: params.salesOrderId,
    cancel_reason: params.cancelReason,
    mode: "LIVE",
  });
  const result = invoked.data ?? {};
  return {
    success: invoked.success && result.success !== false,
    error: invoked.error || result.error,
    provider_cancel_status: result.provider_cancel_status,
  };
}
